import { isEmpty } from 'lodash'
export default function onSubmitInfoMapping(mapping_id) {

  if( isEmpty(mapping_id) ) {
    return null;
  }

  mapping_id = mapping_id.split("/")
  mapping_id = mapping_id[mapping_id.length - 1]

  return mapping_id;
}
